/**
 * Created by mykurisu on 2017/11/2.
 */
import React from 'react'
import {connect} from 'react-redux'
import {Mask} from 'react-weui'
import {WKBottomBtn} from '../wk'
import {renderMoney} from '../../utils'
import '../../css/common/CouponBar.css'


class CouponPay extends React.Component {

    render() {
        const btnContent = {
            text: '下一步',
            method: () => {
                this.props.btnMethod ? this.props.btnMethod() : null
            }
        };

        return (
            <div className="couponpay__container">
                <Mask onClick={() => this.props.handleClose()}/>
                <div className={`couponpay`}>
                    <div className="couponpay__content">
                        <div className="content__item">
                            <p>原始费用</p>
                            <p>￥{renderMoney(this.props.oldPrice)}</p>
                        </div>
                        <div className="content__item" onClick={() => {
                            this.props.dispatch({
                                type: 'COUPON_SELECT_SHOW'
                            })
                        }}>
                            <p>选择优惠</p>
                            <p className="money discount__kurisu">已用优惠券抵扣￥{renderMoney(this.props.coupon.price)}</p>
                        </div>
                        <div className="content__item">
                            <p>还需支付</p>
                            <p className="money">￥{renderMoney(
                                (this.props.oldPrice - this.props.coupon.price) <= 0
                                    ?
                                    '0'
                                    :
                                    (this.props.oldPrice - this.props.coupon.price)
                            )}</p>
                        </div>
                    </div>
                    <WKBottomBtn btnContent={btnContent}/>
                </div>
            </div>
        )
    }
}

export default connect(state => ({

}))(CouponPay)



// WEBPACK FOOTER //
// ./src/components/details/CouponPay.js